import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createShippingZone } from "../../api/apiShipping";
import parseError from "../../utils/parseError";

export const useCreateShippingZone = () => {
    const queryClient = useQueryClient();

    const { mutate: createShippingZoneMutate, isPending: isCreating } = useMutation({
        mutationFn: createShippingZone,
        onSuccess: (res) => {
            toast.success(res.message || "Shipping zone created successfully");
            queryClient.invalidateQueries(["shipping-zones"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to create shipping zone");
        },
    });

    return { createShippingZoneMutate, isCreating };
};
